import React, { useEffect, useState } from "react";
import classNames from "classnames/bind";
import { useNavigate } from "react-router-dom";
import { Table as TB, Pagination } from "../../../../components";
import PropType from "prop-types";
import { userManagement } from "../../../../services/api/userManagementApi";
import { Toast, Alert } from "../../../../components";
import { formatDDMMYY, sorterArray } from '../../../../utils/index'
import Nodata from "../../../History/NoData/Nodata";
import styles from "./Table.module.css";
import NameCol from "../../../../components/NameCol";
import ModalRole from "../Modal";

const cx = classNames.bind(styles);
const Table = ({ listUser, pages, setIsRefresh, isRefresh, onGetUser }) => {
  const navigate = useNavigate()
  const [isAlert, setIsAlert] = useState(false);
  const [user, setUser] = useState({ userName: '', typeCode: '' });
  const [action, setAction] = useState("Xác nhận");
  const [toggleSort, setToggleSort] = useState(false)
  const [dataTable, setDataTable] = useState()
  const [method, setMethod] = useState('')
  const [changeRole, setChangeRole] = useState(false)

  useEffect(() => {
    const newData = listUser.length > 0 ? [...listUser] : null
    if (newData && method.length > 0) {
      switch (toggleSort) {
        case 'up':
          const dataSortUp = sorterArray(newData, method)
          setDataTable(dataSortUp)
          break;
        case 'down':
          const dataSortDown = sorterArray(newData, method)
          setDataTable(dataSortDown.reverse())
          break;
        default:
          setDataTable(newData)
          break;
      }
    } else {
      setDataTable(newData)
    }
  }, [listUser, toggleSort, method])

  const handleSort = (type, method) => {
    if (type !== toggleSort) {
      setToggleSort(type)
      setMethod(method)
    } else {
      setToggleSort(false)
      setMethod('')
    }
  }

  const handleChangeRole = () => {
    setChangeRole(!changeRole)
  }

  const columns = [
    {
      label: "STT",
      key: "stt",
    },
    {
      label: <NameCol active={method} title={'Người dùng'} handleSort={handleSort} method={'NAME'} />,
      key: "user",
    },
    {
      label: <NameCol active={method} title={"Công ty trực thuộc"} handleSort={handleSort} method={'COMPANY_NAME'} />,
      key: "company",
    },
    {
      label: <NameCol active={method} title={"Quyền"} handleSort={handleSort} method={'TYPE_NAME'} />,
      key: "role",
    },
    {
      label: <NameCol active={method} title={"Trạng thái"} handleSort={handleSort} method={'USERNAME'} />,
      key: "status",
    },
    {
      label: <NameCol active={method} title={"Ngày đăng ký"} handleSort={handleSort} method={'EDIT_TIME'} />,
      key: "date",
    },
    {
      label: "Hành động",
      key: "action",
    },
  ];
  const dataSource = dataTable?.map((item, index) => {
    return {
      stt: index + 1,
      user: item.NAME,
      date: formatDDMMYY(item.EDIT_TIME),
      company: item.COMPANY_NAME,
      role: item.TYPE_NAME,
      status: <div className={cx("status")}>Chờ xác nhận</div>,
      action: (
        <div className={cx("actions")}>
          <button
            onClick={(e) => handleConfirm(item.USERNAME, item.USERTYPE_CODE)}
            className={cx("btn", "confirm")}
          >
            Xác nhận
          </button>
          <button
            onClick={(e) => handleCancel(item.USERNAME)}
            className={cx("btn", "cancel")}
          >
            Từ chối
          </button>
        </div>
      ),
    };
  });
  const handleConfirm = (username, typeCode) => {
    setUser({ userName: username, typeCode: typeCode });
    onGetUser({ userName: username, typeCode: typeCode })
    // setIsAlert(true);
    // setAction("Xác nhận");
    setChangeRole(!changeRole)
  };
  const handleCancel = (username) => {
    setUser(username);
    setIsAlert(true);
    setAction("Từ chối");
  };
  const handleClose = () => {
    setIsAlert(false);
  };
  const handleOK = () => {
    if (action === "Từ chối") {
      const unverify = async () => {
        try {
          const res = await userManagement.unverify(user);
          if (res.result) {
            Toast.open("Từ chối thành công", "success");
            setIsRefresh(!isRefresh);
          } else {
            Toast.open("Từ chối không thành công", "danger");
          }
        } catch (e) {
          Toast.open("Từ chối không thành công", "danger");
        }
      };
      unverify();
    }
    setIsAlert(false);
  };

  const handleChoosePage = () => {
    return 0
  }
  const handleNextPage = () => {
    return 0
  }
  const handlePrevious = () => {
    return 0
  }
  return (
    <div>
      {isAlert && (
        <Alert
          onOk={handleOK}
          onClose={handleClose}
          title={action === "Xác nhận" ? "Bạn có muốn xác nhận không" : "Bạn có muốn từ chối không"}
        />
      )}
      {changeRole && <ModalRole onClose={handleChangeRole}/>}
      <TB data={dataSource} colum={columns} />
      {
        dataSource?.length > 0 ? <div className={cx("pagination")}>
        <Pagination pages={pages} currentPage={1} onClick={handleChoosePage} onNext={handleNextPage} onPrevious={handlePrevious} />
      </div>:<Nodata/>
      }
    </div>
  );
};
Table.propTypes = {
  listUser: PropType.array.isRequired,
  pages: PropType.number.isRequired,
  setIsRefresh: PropType.any.isRequired,
  isRefresh: PropType.bool.isRequired,
};
export default Table;
